<template>
    <div class="container">
      <b-carousel
                    id="carousel-1"
                    :interval="4000"
                    controls
                    indicators
                    background="#ababab"
                    style="text-shadow: 1px 1px 2px #333;"
                    width="1110"
                    height="500"
                >
                    <b-carousel-slide>
                        <template v-slot:img>
                            <img
                                width="1110"
                                height="500"
                                src="/images/IMGP0959-1-1110x500.jpg"
                                class="slide"

                            />
                                                            <!-- alt
                                data-srcset="/images/IMGP0959-1-1110x500.jpg 1110w, /images/IMGP0959-1-300x136.jpg 300w, /images/IMGP0959-1-517x235.jpg 517w"
                                data-sizes="(max-width: 1110px) 100vw, 1110px" -->
                        </template>
                    </b-carousel-slide>
                    <b-carousel-slide>
                        <template v-slot:img>
                            <img
                                width="1110"
                                height="500"
                                src="/images/IMGP0594-1110x500.jpg"
                                class="slide"
                            />
                                                            <!-- alt
                                data-srcset="/images/IMGP0594-1110x500.jpg 1110w, /images/IMGP0594-517x235.jpg 517w"
                                data-sizes="(max-width: 1110px) 100vw, 1110px" -->
                        </template>
                    </b-carousel-slide>
                    <b-carousel-slide>
                        <template v-slot:img>
                            <img
                                width="1110"
                                height="500"
                                src="/images/IMGP0616-1110x500.jpg"
                                class="slide"
                            />
                                                            <!-- alt
                                data-srcset="/images/IMGP0616-1110x500.jpg 1110w, /images/IMGP0616-517x235.jpg 517w"
                                data-sizes="(max-width: 1110px) 100vw, 1110px" -->
                        </template>
                    </b-carousel-slide>
                </b-carousel>
        <div id="main-wrapper" class="section">
            <div class="container marketing center-images-enabled">
                
                <div class="row fp-widget-area" role="complementary">
                    <!-- <div class="featured-page col-12 col-md-4 fp-one">
                        <div class="widget-front czr-link-mask-p round">
                            <h4 class="fp-title">About Wersa</h4>
                            <p
                                class="fp-text-one"
                            >South African National Location system</p>
                            <span class="fp-button readmore-holder">
                                <a
                                    class="moretag btn btn-more btn-skin-dark"
                                    href="http://wersa.co.za/about/"
                                >
                                    <span>Read more &raquo;</span>
                                </a>
                            </span>
                        </div>
                    </div>-->
                    <!--/.fp-->
                    <div class="featured-page col-12 col-md-4 fp-two">
                        <div class="widget-front czr-link-mask-p round">
                            <h4 class="fp-title">Get Our App</h4>
                            <p class="fp-text-two">Download for FREE</p>
                            <span class="fp-button readmore-holder">
                                <a class="moretag btn btn-more btn-skin-dark btn-secondary" href="/app/">
                                    <span>Read more &raquo;</span>
                                </a>
                            </span>
                        </div>
                        <!--/.widget-front-->
                    </div>
                    <!--/.fp-->
                    <div class="featured-page col-12 col-md-4 fp-two">
                        <div class="widget-front czr-link-mask-p round">
                            <h4 class="fp-title">Developers' Resources</h4>
                            <p class="fp-text-two">Add to your website</p>
                            <span class="fp-button readmore-holder">
                                <a class="moretag btn btn-more btn-skin-dark btn-secondary" href="/resources/">
                                    <span>Read more &raquo;</span>
                                </a>
                            </span>
                        </div>
                        <!--/.widget-front-->
                    </div>
                    <!--/.fp-->
                    <!-- <div class="featured-page col-12 col-md-4 fp-three">
                        <div class="widget-front czr-link-mask-p round">
                            <h4 class="fp-title">Privacy Policy &#038; Terms</h4>
                            <p class="fp-text-three">Our Privacy Policy and Terms of Use</p>
                            <span class="fp-button readmore-holder">
                                <a
                                    class="moretag btn btn-more btn-skin-dark btn-secondary"
                                    href="/privacy-policy-and-terms-of-use/"
                                >
                                    <span>Read more &raquo;</span>
                                </a>
                            </span>
                        </div>
                    </div> -->
                     <div class="featured-page col-12 col-md-4 fp-three">
                        <div class="widget-front czr-link-mask-p round">
                            <h4 class="fp-title">Help &#038; Support</h4>
                            <p class="fp-text-three">Watch the instruction video</p>
                            <span class="fp-button readmore-holder">
                                <a
                                    class="moretag btn btn-more btn-skin-dark btn-secondary"
                                    href="/help-support/"
                                >
                                    <span>Read more &raquo;</span>
                                </a>
                            </span>
                        </div>
                        <!--/.widget-front-->
                    </div>
                    <!--/.fp-->
                </div>
            </div>

            <div class="container" role="main">
                <div class="flex-row row column-content-wrapper">
                    <div id="content" class="col-12 article-container"></div>
                </div>
                <!-- .column-content-wrapper -->
            </div>
            <!-- .container -->

            <div id="czr-push-footer"></div>
        </div>
        <!-- #main-wrapper -->
    </div>
</template>

<style id='customizr-main-inline-css' type='text/css'>
.tc-header.border-top {
    border-top-width: 5px;
    border-top-style: solid;
}

.no-csstransforms3d .czr-slider-loader-wrapper .czr-img-gif-loader {
    background: url("/images/slider-loader.gif") no-repeat center center;
}

#customizr-slider-main_slider.czr-carousel {
    height: 500px;
}
#customizr-slider-main_slider .czr-slider-loader-wrapper {
    line-height: 500px;
    height: 500px;
}
@media (max-width: 1199px) {
    #customizr-slider-main_slider.czr-carousel {
        height: 385px;
    }
    #customizr-slider-main_slider .czr-slider-loader-wrapper {
        line-height: 385px;
        height: 385px;
    }
}
@media (max-width: 991px) {
    #customizr-slider-main_slider.czr-carousel {
        height: 309px;
    }
    #customizr-slider-main_slider .czr-slider-loader-wrapper {
        line-height: 309px;
        height: 309px;
    }
}
@media (max-width: 767px) {
    #customizr-slider-main_slider.czr-carousel {
        height: 250px;
    }
    #customizr-slider-main_slider .czr-slider-loader-wrapper {
        line-height: 250px;
        height: 250px;
    }
}
@media (max-width: 575px) {
    #customizr-slider-main_slider.czr-carousel {
        height: 190px;
    }
    #customizr-slider-main_slider .czr-slider-loader-wrapper {
        line-height: 190px;
        height: 190px;
    }
}
@media (max-width: 320px) {
    #customizr-slider-main_slider.czr-carousel {
        height: 140px;
    }
    #customizr-slider-main_slider .czr-slider-loader-wrapper {
        line-height: 140px;
        height: 140px;
    }
}
#czr-push-footer {
    display: none;
    visibility: hidden;
}
.czr-sticky-footer #czr-push-footer.sticky-footer-enabled {
    display: block;
}
</style>

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

<script>
export default {
    metaInfo() {
        return {
            title: "Home | Wersa",
            link: [
                { rel: 'canonical', href: 'https://wersa.co.za/' }
            ]
        };
    }
};
</script>